const e = {
  name: "JapaneseYen",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M15,19h3.4l-4-8h2.2l3.4,6.8l3.4-6.8h2.2l-4,8H25v2h-4v2h4v2h-4v4h-2v-4h-4v-2h4v-2h-4V19z"/>
		<path class="st0" d="M0,20C0,9,9,0,20,0c11,0,20,9,20,20s-9,20-20,20C9,40,0,31,0,20z M20,2C10.1,2,2,10.1,2,20s8.1,18,18,18
			c9.9,0,18-8.1,18-18S29.9,2,20,2z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as JapaneseYen
};
